import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'book-flower-house',
  label: {
    title: '花城书房',
    icon: require('@/assets/icon-component-lanel_BookFlowerHouse.svg'),
    limit: -1,
    show: () => Number(platformType) === 1,
  },
  sort: 104,
  data: {
    flowers: []
  },
  settings: {
    flowers: {
      type: SettingTypes.custom,
      component_name: 'BookFlowerHouseSelector'
    }
  }
}
